<nz-form-label [attr.nzFor]="formFieldInfo.fieldCode" [hidden]="hideTitle" nzNoColon>
    <span>{{name}} <span *ngIf="formFieldInfo.isRequired" style="color:red;">(*)</span></span>
    <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
</nz-form-label>
<nz-form-control [formGroup]="formGroup">
    <nz-date-picker style="width:100%" [id]="formFieldInfo.fieldCode" nzShowTime nzPlaceHolder="Định dạng nhập yyyy-MM-dd HH:mm"
        nzFormat="yyyy-MM-dd HH:mm" [nzDisabledDate]="disabledDates" [formControlName]="formFieldInfo.fieldCode"
        nzSize="large" [(ngModel)]="value" (ngModelChange)="modelChange()">
    </nz-date-picker>
</nz-form-control>